(function (global) {
  const CONTAINER_ID = 'vr-tutorial-container';
  const VIDEO_ID = 'vr-tutorial-native-video';
  const LOGO_ID = 'vr-tutorial-logo';
  const OVERLAY_HOST_ID = 'tutorial-vr-native-overlay-host';
  const OVERLAY_PIXEL_WIDTH = 720;
  const OVERLAY_PIXEL_HEIGHT = 405;
  const PANEL_SCALE = '0.22 0.22 0.22';
  const HIDDEN_POS = '0 12.5 -0.85';
  const SHOWN_POS = '0 2.08 -0.85';
  const U = 1 / 200;
  const W = 1260 * U;
  const H = 600 * U;
  const PAD_X = 24 * U;
  const PAD_TOP = 18 * U;
  const PAD_BOTTOM = 12 * U;
  const RADIUS = 16 * U;
  const GAP_SECTION = 14 * U;
  const GAP_FOOTER = 10 * U;
  const GAP_BODY = 24 * U;
  const HEADER_H = 44 * U;
  const FOOTER_H = 44 * U;
  const COPY_BULLETS_TOP = 52 * U;
  const COPY_BULLET_LINE_H = 34 * U;
  const COPY_DIVIDER_GAP = 16 * U;
  const COPY_NOTE_GAP = 12 * U;
  const COPY_NOTE_EXTENT = 52 * U;
  const INNER_W = W - PAD_X * 2;
  const MEDIA_W = (INNER_W - GAP_BODY) * 1.25 / 2;
  const COPY_W = (INNER_W - GAP_BODY) * 0.75 / 2;
  const MEDIA_H = MEDIA_W * 9 / 16;
  const LEFT = -INNER_W / 2;
  const RIGHT = INNER_W / 2;
  const TOP = H / 2 - PAD_TOP;
  const BOTTOM = -H / 2 + PAD_BOTTOM;
  const MEDIA_X = LEFT + MEDIA_W / 2;
  const COPY_LEFT = LEFT + MEDIA_W + GAP_BODY;
  const BODY_TOP = TOP - HEADER_H - GAP_SECTION;
  const BODY_CENTER_Y = BODY_TOP - MEDIA_H / 2;
  const BODY_BOTTOM = BODY_TOP - MEDIA_H;

  let rootEl = null;
  let panelEl = null;
  let panelBorderEl = null;
  let stepTitleEl = null;
  let subtitleTextEl = null;
  let bulletsTextEl = null;
  let noteTextEl = null;
  let dividerEl = null;
  let nextBtnEl = null;
  let prevBtnEl = null;
  let skipBtnEl = null;
  let closeHitboxEl = null;
  let closeTextEl = null;
  let closeBgEl = null;
  let closeGroupEl = null;
  let closeBgNormalColor = '#202028';
  let closeBgHoverColor = '#343448';
  let dotsRootEl = null;
  let footerGroupEl = null;
  let videoAssetEl = null;
  let videoEntityEl = null;
  let videoBgEl = null;
  let mediaGroupEl = null;
  let overlayMeshEl = null;
  let overlayHostEl = null;
  let overlaySvgEl = null;
  let visible = false;
  let handlers = {};
  let totalSteps = 0;
  let activeStepIndex = -1;
  let bloomSuppressed = false;
  let bloomWasEnabled = true;

  function getSceneEl() {
    return document.getElementById('main-scene');
  }

  function getSceneAssets() {
    const scene = getSceneEl();
    if (!scene) {
      return null;
    }
    let assets = scene.querySelector('a-assets');
    if (!assets) {
      assets = document.createElement('a-assets');
      scene.insertBefore(assets, scene.firstChild);
    }
    return assets;
  }

  function ensureVideoAsset() {
    const assets = getSceneAssets();
    if (!assets) {
      return null;
    }
    if (!videoAssetEl) {
      videoAssetEl = document.getElementById(VIDEO_ID);
    }
    if (!videoAssetEl) {
      videoAssetEl = document.createElement('video');
      videoAssetEl.id = VIDEO_ID;
      videoAssetEl.setAttribute('crossorigin', 'anonymous');
      videoAssetEl.setAttribute('loop', '');
      videoAssetEl.setAttribute('muted', '');
      videoAssetEl.setAttribute('playsinline', '');
      videoAssetEl.playsInline = true;
      videoAssetEl.muted = true;
      videoAssetEl.loop = true;
      assets.appendChild(videoAssetEl);
    }
    return videoAssetEl;
  }

  function ensureLogoAsset() {
    const assets = getSceneAssets();
    if (!assets) {
      return null;
    }
    if (!document.getElementById(LOGO_ID)) {
      const logo = document.createElement('img');
      logo.id = LOGO_ID;
      logo.setAttribute('crossorigin', 'anonymous');
      logo.src = './desktop_assets/tutorial/svg-icons/icon-logo.svg';
      assets.appendChild(logo);
    }
    return document.getElementById(LOGO_ID);
  }

  function ensureContainer() {
    let container = document.getElementById(CONTAINER_ID);
    if (!container) {
      const scene = getSceneEl();
      if (!scene) {
        return null;
      }
      container = document.createElement('a-entity');
      container.id = CONTAINER_ID;
      container.setAttribute('vr-tutorial-panel', '');
      container.setAttribute('scale', PANEL_SCALE);
      container.setAttribute('position', HIDDEN_POS);
      container.setAttribute('visible', 'false');
      scene.appendChild(container);
    }
    return container;
  }

  function getPanelComponent() {
    if (!rootEl || !rootEl.components) {
      return null;
    }
    return rootEl.components['vr-tutorial-panel'] || null;
  }

  function showContainer() {
    if (!rootEl) {
      return;
    }
    const comp = getPanelComponent();
    if (comp && typeof comp.show === 'function') {
      comp.show();
      return;
    }
    rootEl.setAttribute('visible', true);
    rootEl.setAttribute('position', SHOWN_POS);
  }

  function hideContainer() {
    if (!rootEl) {
      return;
    }
    const comp = getPanelComponent();
    if (comp && typeof comp.hide === 'function') {
      comp.hide();
      return;
    }
    rootEl.setAttribute('visible', false);
    rootEl.setAttribute('position', HIDDEN_POS);
  }

  function createGroup(id) {
    const group = document.createElement('a-entity');
    if (id) {
      group.id = id;
    }
    return group;
  }

  function ensureNativeOverlayHost() {
    if (!overlayHostEl) {
      overlayHostEl = document.getElementById(OVERLAY_HOST_ID);
    }
    if (!overlayHostEl) {
      overlayHostEl = document.createElement('div');
      overlayHostEl.id = OVERLAY_HOST_ID;
      overlayHostEl.className = '';
      overlayHostEl.style.position = 'fixed';
      overlayHostEl.style.left = '-10000px';
      overlayHostEl.style.top = '0';
      overlayHostEl.style.width = OVERLAY_PIXEL_WIDTH + 'px';
      overlayHostEl.style.height = OVERLAY_PIXEL_HEIGHT + 'px';
      overlayHostEl.style.pointerEvents = 'none';
      overlayHostEl.style.overflow = 'visible';
      const svgRoot = document.createElement('div');
      svgRoot.className = 'tutorial-overlay-svg';
      overlayHostEl.appendChild(svgRoot);
      document.body.appendChild(overlayHostEl);
    }
    overlaySvgEl = overlayHostEl.querySelector('.tutorial-overlay-svg');
    return overlayHostEl;
  }

  function ensureNativeOverlayMesh(mediaGroup) {
    return null;
  }

  function refreshOverlayMesh() {
    return;
  }

  function getOverlaySvgEl() {
    ensureNativeOverlayHost();
    return overlaySvgEl;
  }

  function getCopyBlockMetrics(step, bullets) {
    const bulletCount = Array.isArray(bullets) ? bullets.length : 0;
    const hasNote = Boolean(step && step.note);
    const hasSubtitle = Boolean(step && step.subtitle);
    const bulletsY = hasSubtitle ? -COPY_BULLETS_TOP : -40 * U;
    let contentEndY = bulletsY;

    if (bulletCount > 0) {
      contentEndY = bulletsY - bulletCount * COPY_BULLET_LINE_H;
    }

    let dividerY = null;
    let noteY = null;
    if (hasNote) {
      dividerY = contentEndY - COPY_DIVIDER_GAP;
      noteY = dividerY - COPY_DIVIDER_GAP - COPY_NOTE_GAP;
      contentEndY = noteY - COPY_NOTE_EXTENT;
    }

    return {
      bulletsY: bulletsY,
      dividerY: dividerY,
      noteY: noteY,
      hasNote: hasNote,
      copyDepth: Math.max(0, -contentEndY)
    };
  }

  function applyCopyLayout(step, bullets) {
    const metrics = getCopyBlockMetrics(step, bullets);

    if (bulletsTextEl) {
      bulletsTextEl.setAttribute('position', '0 ' + metrics.bulletsY + ' 0');
    }
    if (dividerEl) {
      if (metrics.hasNote) {
        dividerEl.setAttribute('position', (COPY_W / 2) + ' ' + metrics.dividerY + ' 0');
        dividerEl.setAttribute('visible', 'true');
      } else {
        dividerEl.setAttribute('visible', 'false');
      }
    }
    if (noteTextEl && metrics.hasNote) {
      noteTextEl.setAttribute('position', '0 ' + metrics.noteY + ' 0');
    }
  }

  function resolveContentBottom(step, bullets) {
    const copyDepth = getCopyBlockMetrics(step, bullets).copyDepth;
    return BODY_TOP - Math.max(MEDIA_H, copyDepth);
  }

  function resolveFooterY(step, bullets) {
    const contentBottom = resolveContentBottom(step, bullets);
    const footerY = contentBottom - GAP_FOOTER - FOOTER_H / 2;
    const minFooterY = BOTTOM + PAD_BOTTOM + FOOTER_H / 2;
    return Math.max(footerY, minFooterY);
  }

  function repositionFooter(step, bullets) {
    const footerY = resolveFooterY(step, bullets);
    if (dotsRootEl) {
      dotsRootEl.setAttribute('position', LEFT + ' ' + footerY + ' 0.02');
    }
    if (footerGroupEl) {
      footerGroupEl.setAttribute('position', RIGHT + ' ' + footerY + ' 0.02');
    }
  }

  function createTroika(value, fontSize, options) {
    const text = document.createElement('a-troika-text');
    text.setAttribute('value', value || '');
    text.setAttribute('font-size', fontSize);
    text.setAttribute('color', options && options.color ? options.color : '#ffffff');
    text.setAttribute('anchor', options && options.anchor ? options.anchor : 'left');
    text.setAttribute('align', options && options.align ? options.align : 'left');
    text.setAttribute('baseline', options && options.baseline ? options.baseline : 'top');
    text.setAttribute('max-width', options && options.maxWidth ? options.maxWidth : COPY_W);
    text.setAttribute('line-height', options && options.lineHeight ? options.lineHeight : 1.45);
    if (options && options.fontWeight) {
      text.setAttribute('font-weight', options.fontWeight);
    }
    return text;
  }

  function createActionButton(label, scheme, width) {
    const btn = document.createElement('a-entity');
    btn.setAttribute('ui-button', {
      label: label,
      type: 'rounded-box',
      width: width,
      height: 0.2,
      depth: 0.008,
      radius: 0.04,
      colorScheme: scheme,
      preferredFontSize: 0.07
    });
    btn.setAttribute('data-raycastable', '');
    return btn;
  }

  function bindButton(btn, callback) {
    if (!btn || btn.__vrTutorialBound) {
      return;
    }
    btn.__vrTutorialBound = true;
    btn.addEventListener('click', (evt) => {
      evt.stopPropagation();
      if (typeof callback === 'function') {
        callback();
      }
    });
  }

  function layoutFooterButtons(specs) {
    let cursor = 0;
    specs.forEach((spec) => {
      cursor -= spec.width / 2;
      spec.el.setAttribute('position', cursor + ' 0 0');
      cursor -= spec.width / 2 + spec.gap;
    });
  }

  function setCloseButtonBgColor(color) {
    if (!closeBgEl) {
      return;
    }
    closeBgEl.setAttribute('color', color);
    closeBgEl.setAttribute('material', 'shader: flat; color: ' + color + '; side: double');
  }

  function setCloseButtonHovered(hovered) {
    setCloseButtonBgColor(hovered ? closeBgHoverColor : closeBgNormalColor);
    if (!closeGroupEl) {
      return;
    }
    const scale = hovered ? 1.08 : 1;
    closeGroupEl.setAttribute('animation__hover', {
      property: 'scale',
      to: scale + ' ' + scale + ' ' + scale,
      dur: 120,
      easing: 'easeOutQuad'
    });
  }

  function bindCloseButtonHover(btn) {
    if (!btn || btn.__vrTutorialHoverBound) {
      return;
    }
    btn.__vrTutorialHoverBound = true;
    btn.addEventListener('mouseenter', () => {
      setCloseButtonHovered(true);
    });
    btn.addEventListener('mouseleave', () => {
      setCloseButtonHovered(false);
    });
  }

  function buildCloseButton(headerY) {
    const closeSize = 44 * U;
    closeGroupEl = createGroup('vr-tutorial-close');
    closeGroupEl.setAttribute('position', (RIGHT - 18 * U) + ' ' + headerY + ' 0.05');

    closeBgEl = document.createElement('a-rounded-box');
    closeBgEl.setAttribute('width', closeSize);
    closeBgEl.setAttribute('height', closeSize);
    closeBgEl.setAttribute('depth', 0.003);
    closeBgEl.setAttribute('radius', 8 * U);
    closeBgEl.setAttribute('color', closeBgNormalColor);
    closeBgEl.setAttribute('material', 'shader: flat; color: ' + closeBgNormalColor + '; side: double');
    closeBgEl.setAttribute('position', '0 0 0');
    closeGroupEl.appendChild(closeBgEl);

    closeTextEl = createTroika('X', 30 * U, {
      color: '#ffffff',
      anchor: 'center',
      align: 'center',
      baseline: 'center',
      fontWeight: '600',
      maxWidth: closeSize
    });
    closeTextEl.setAttribute('position', '0 0 0.004');
    closeGroupEl.appendChild(closeTextEl);

    closeHitboxEl = document.createElement('a-plane');
    closeHitboxEl.setAttribute('class', 'close-button');
    closeHitboxEl.setAttribute('width', closeSize);
    closeHitboxEl.setAttribute('height', closeSize);
    closeHitboxEl.setAttribute('material', 'transparent: true; opacity: 0');
    closeHitboxEl.setAttribute('position', '0 0 0.005');
    closeHitboxEl.setAttribute('data-raycastable', '');
    closeGroupEl.appendChild(closeHitboxEl);

    bindButton(closeHitboxEl, () => {
      if (typeof handlers.onClose === 'function') {
        handlers.onClose();
      }
    });
    bindCloseButtonHover(closeHitboxEl);

    rootEl.appendChild(closeGroupEl);
  }

  function buildPanel() {
    if (panelEl && rootEl) {
      return true;
    }
    rootEl = ensureContainer();
    if (!rootEl) {
      return false;
    }

    ensureVideoAsset();
    ensureLogoAsset();
    rootEl.innerHTML = '';

    panelBorderEl = document.createElement('a-rounded-box');
    panelBorderEl.setAttribute('width', W + 0.008);
    panelBorderEl.setAttribute('height', H + 0.008);
    panelBorderEl.setAttribute('depth', 0.004);
    panelBorderEl.setAttribute('radius', RADIUS);
    panelBorderEl.setAttribute('color', '#3636e3');
    panelBorderEl.setAttribute('material', 'shader: flat; color: #3636e3');
    panelBorderEl.setAttribute('position', '0 0 -0.002');
    panelBorderEl.setAttribute('data-raycastable', '');
    rootEl.appendChild(panelBorderEl);

    panelEl = document.createElement('a-rounded-box');
    panelEl.setAttribute('width', W);
    panelEl.setAttribute('height', H);
    panelEl.setAttribute('depth', 0.006);
    panelEl.setAttribute('radius', RADIUS);
    panelEl.setAttribute('color', '#14141c');
    panelEl.setAttribute('material', 'shader: flat; color: #14141c');
    panelEl.setAttribute('position', '0 0 0');
    panelEl.setAttribute('data-raycastable', '');
    rootEl.appendChild(panelEl);

    const headerY = TOP - HEADER_H / 2;
    const logoH = 40 * U;
    const logoW = logoH * 1.55;

    const logo = document.createElement('a-plane');
    logo.setAttribute('src', '#' + LOGO_ID);
    logo.setAttribute('width', logoW);
    logo.setAttribute('height', logoH);
    logo.setAttribute('material', 'shader: flat; transparent: true; alphaTest: 0.01; side: double');
    logo.setAttribute('position', (LEFT + logoW / 2) + ' ' + headerY + ' 0.01');
    rootEl.appendChild(logo);

    const brandAccent = createTroika('StockStorm.ai', 18 * U, {
      color: '#3636e3',
      fontWeight: '600',
      maxWidth: 1.4
    });
    brandAccent.setAttribute('position', (LEFT + logoW + 10 * U) + ' ' + (headerY + logoH * 0.15) + ' 0.021');
    rootEl.appendChild(brandAccent);

    const brandRest = createTroika(' Tutorial', 18 * U, {
      color: '#ffffff',
      fontWeight: '600',
      maxWidth: 0.9
    });
    brandRest.setAttribute('position', (LEFT + logoW + 10 * U + 0.58) + ' ' + (headerY + logoH * 0.15) + ' 0.021');
    rootEl.appendChild(brandRest);

    mediaGroupEl = createGroup('vr-tutorial-media');
    mediaGroupEl.setAttribute('position', MEDIA_X + ' ' + BODY_CENTER_Y + ' 0.01');
    rootEl.appendChild(mediaGroupEl);
    const mediaGroup = mediaGroupEl;

    videoBgEl = document.createElement('a-plane');
    videoBgEl.setAttribute('width', MEDIA_W);
    videoBgEl.setAttribute('height', MEDIA_H);
    videoBgEl.setAttribute('color', '#262630');
    videoBgEl.setAttribute('material', 'shader: flat; color: #262630; toneMapped: false');
    videoBgEl.setAttribute('position', '0 0 -0.01');
    mediaGroup.appendChild(videoBgEl);

    videoEntityEl = document.createElement('a-video');
    videoEntityEl.setAttribute('src', '#' + VIDEO_ID);
    videoEntityEl.setAttribute('width', MEDIA_W - 0.008);
    videoEntityEl.setAttribute('height', MEDIA_H - 0.008);
    videoEntityEl.setAttribute('position', '0 0 0.02');
    videoEntityEl.setAttribute('material', 'shader: flat; toneMapped: false');
    mediaGroup.appendChild(videoEntityEl);

    const copyGroup = createGroup('vr-tutorial-copy');
    copyGroup.setAttribute('position', COPY_LEFT + ' ' + BODY_TOP + ' 0.01');
    rootEl.appendChild(copyGroup);

    stepTitleEl = createTroika('', 20 * U, {
      color: '#ffffff',
      fontWeight: '600',
      maxWidth: COPY_W,
      lineHeight: 1.25
    });
    stepTitleEl.setAttribute('position', '0 0 0');
    copyGroup.appendChild(stepTitleEl);

    subtitleTextEl = createTroika('', 14 * U, {
      color: '#ffffff',
      fontWeight: '600',
      maxWidth: COPY_W,
      lineHeight: 1.45
    });
    subtitleTextEl.setAttribute('position', '0 ' + (-28 * U) + ' 0');
    copyGroup.appendChild(subtitleTextEl);

    bulletsTextEl = createTroika('', 14 * U, {
      color: 'rgba(255,255,255,0.5)',
      maxWidth: COPY_W,
      lineHeight: 1.45
    });
    bulletsTextEl.setAttribute('position', '0 ' + (-52 * U) + ' 0');
    copyGroup.appendChild(bulletsTextEl);

    dividerEl = document.createElement('a-plane');
    dividerEl.setAttribute('width', COPY_W);
    dividerEl.setAttribute('height', 1 * U);
    dividerEl.setAttribute('color', '#2a2a35');
    dividerEl.setAttribute('position', (COPY_W / 2) + ' ' + (-120 * U) + ' 0');
    dividerEl.setAttribute('visible', false);
    copyGroup.appendChild(dividerEl);

    noteTextEl = createTroika('', 14 * U, {
      color: 'rgba(255,255,255,0.5)',
      maxWidth: COPY_W,
      lineHeight: 1.45
    });
    noteTextEl.setAttribute('position', '0 ' + (-140 * U) + ' 0');
    copyGroup.appendChild(noteTextEl);

    dotsRootEl = createGroup('vr-tutorial-dots');
    dotsRootEl.setAttribute('position', LEFT + ' ' + resolveFooterY({}, []) + ' 0.02');
    rootEl.appendChild(dotsRootEl);

    footerGroupEl = createGroup('vr-tutorial-footer');
    footerGroupEl.setAttribute('position', RIGHT + ' ' + resolveFooterY({}, []) + ' 0.02');
    rootEl.appendChild(footerGroupEl);

    const footerGroup = footerGroupEl;

    const btnGap = 10 * U;
    const btnNextW = 0.82;
    const btnSkipW = 0.92;
    const btnPrevW = 0.98;

    nextBtnEl = createActionButton('Next tip', 'cta', btnNextW);
    footerGroup.appendChild(nextBtnEl);
    bindButton(nextBtnEl, () => {
      if (typeof handlers.onNext === 'function') {
        handlers.onNext();
      }
    });

    skipBtnEl = createActionButton('Skip tutorial', 'primary', btnSkipW);
    footerGroup.appendChild(skipBtnEl);
    bindButton(skipBtnEl, () => {
      if (typeof handlers.onSkip === 'function') {
        handlers.onSkip();
      }
    });

    prevBtnEl = createActionButton('Previous tip', 'primary', btnPrevW);
    footerGroup.appendChild(prevBtnEl);
    bindButton(prevBtnEl, () => {
      if (typeof handlers.onPrev === 'function') {
        handlers.onPrev();
      }
    });

    layoutFooterButtons([
      { el: nextBtnEl, width: btnNextW, gap: btnGap },
      { el: skipBtnEl, width: btnSkipW, gap: btnGap },
      { el: prevBtnEl, width: btnPrevW, gap: btnGap }
    ]);

    buildCloseButton(headerY);

    hideContainer();
    return true;
  }

  function waitForSceneReady(maxAttempts) {
    const attempts = typeof maxAttempts === 'number' ? maxAttempts : 120;
    return new Promise((resolve) => {
      let count = 0;
      const tick = () => {
        const scene = getSceneEl();
        if (scene && (scene.hasLoaded || typeof AFRAME !== 'undefined')) {
          resolve(scene);
          return;
        }
        count += 1;
        if (count >= attempts) {
          resolve(scene || null);
          return;
        }
        setTimeout(tick, 50);
      };
      tick();
    });
  }

  function formatBullets(bullets) {
    if (!Array.isArray(bullets) || !bullets.length) {
      return '';
    }
    return bullets.map((line) => '• ' + line).join('\n');
  }

  function renderDots(stepIndex, stepCount) {
    if (!dotsRootEl) {
      return;
    }
    dotsRootEl.innerHTML = '';
    const dotSize = 10 * U;
    const gap = 8 * U;
    for (let i = 0; i < stepCount; i += 1) {
      const dot = document.createElement('a-plane');
      dot.setAttribute('width', dotSize);
      dot.setAttribute('height', dotSize);
      if (i === stepIndex) {
        dot.setAttribute('color', '#3636e3');
        dot.setAttribute('scale', '1.1 1.1 1');
      } else {
        dot.setAttribute('color', '#2a2a35');
        dot.setAttribute('data-raycastable', '');
        dot.addEventListener('click', (evt) => {
          evt.stopPropagation();
          if (typeof handlers.onDot === 'function') {
            handlers.onDot(i);
          }
        });
      }
      dot.setAttribute('position', (i * (dotSize + gap) + dotSize / 2) + ' 0 0');
      dotsRootEl.appendChild(dot);
    }
  }

  function resolveVideoUrl(url) {
    if (!url) {
      return '';
    }
    try {
      return new URL(url, window.location.href).href;
    } catch (e) {
      return String(url).replace(/^\.\//, '');
    }
  }

  function videoUrlKey(url) {
    if (!url) {
      return '';
    }
    try {
      return decodeURIComponent(new URL(url, window.location.href).pathname).replace(/^\/+/, '');
    } catch (e) {
      return String(url).replace(/^\.\//, '');
    }
  }

  function playVideo(url) {
    const video = ensureVideoAsset();
    if (!video) {
      return;
    }
    if (!url) {
      video.removeAttribute('src');
      video.pause();
      if (videoEntityEl) {
        videoEntityEl.setAttribute('visible', false);
      }
      return;
    }
    const resolvedUrl = resolveVideoUrl(url);
    if (videoEntityEl) {
      videoEntityEl.setAttribute('visible', true);
    }
    const currentKey = videoUrlKey(video.currentSrc || video.getAttribute('src') || video.src || '');
    const nextKey = videoUrlKey(resolvedUrl);
    if (currentKey !== nextKey) {
      video.setAttribute('src', resolvedUrl);
      video.src = resolvedUrl;
      video.load();
      if (videoEntityEl) {
        const entitySrc = videoEntityEl.getAttribute('src');
        if (entitySrc !== '#' + VIDEO_ID) {
          videoEntityEl.setAttribute('src', '#' + VIDEO_ID);
        }
      }
    }
    video.muted = true;
    video.playsInline = true;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function applyTheme(isLight) {
    const bg = isLight ? '#ffffff' : '#14141c';
    const border = '#3636e3';
    const text = isLight ? '#111111' : '#ffffff';
    const bullet = isLight ? 'rgba(17,17,17,0.5)' : 'rgba(255,255,255,0.5)';
    const divider = isLight ? 'rgba(30,30,30,0.12)' : '#2a2a35';
    const videoBg = isLight ? 'rgba(30,30,30,0.06)' : '#262630';
    closeBgNormalColor = isLight ? '#f3f3f6' : '#202028';
    closeBgHoverColor = isLight ? '#e6e6ee' : '#343448';
    if (panelBorderEl) {
      panelBorderEl.setAttribute('color', border);
      panelBorderEl.setAttribute('material', 'shader: flat; color: ' + border);
    }
    if (panelEl) {
      panelEl.setAttribute('color', bg);
      panelEl.setAttribute('material', 'shader: flat; color: ' + bg);
    }
    if (videoBgEl) {
      videoBgEl.setAttribute('color', videoBg);
      videoBgEl.setAttribute('material', 'shader: flat; color: ' + videoBg + '; toneMapped: false');
    }
    if (stepTitleEl) {
      stepTitleEl.setAttribute('color', text);
    }
    if (subtitleTextEl) {
      subtitleTextEl.setAttribute('color', text);
    }
    if (bulletsTextEl) {
      bulletsTextEl.setAttribute('color', bullet);
    }
    if (noteTextEl) {
      noteTextEl.setAttribute('color', bullet);
    }
    if (dividerEl) {
      dividerEl.setAttribute('color', divider);
    }
    if (closeTextEl) {
      closeTextEl.setAttribute('color', text);
    }
    if (closeBgEl) {
      setCloseButtonBgColor(closeBgNormalColor);
    }
  }

  function suppressBloomForTutorial() {
    const scene = getSceneEl();
    if (!scene || bloomSuppressed) {
      return;
    }
    const bloomComponent = scene.components && scene.components.bloom;
    bloomWasEnabled = bloomComponent
      ? bloomComponent.data.enabled !== false
      : true;
    if (bloomWasEnabled) {
      scene.setAttribute('bloom', 'enabled', false);
    }
    bloomSuppressed = true;
  }

  function restoreBloomAfterTutorial() {
    if (!bloomSuppressed) {
      return;
    }
    const scene = getSceneEl();
    if (scene && bloomWasEnabled) {
      scene.setAttribute('bloom', 'enabled', true);
    }
    bloomSuppressed = false;
  }

  function setStep(options) {
    if (!options) {
      return false;
    }
    if (!buildPanel()) {
      return false;
    }

    handlers = {
      onNext: options.onNext,
      onPrev: options.onPrev,
      onSkip: options.onSkip,
      onClose: options.onClose,
      onDot: options.onDot
    };

    const stepIndex = typeof options.stepIndex === 'number' ? options.stepIndex : 0;
    const step = options.step || {};
    const bullets = options.bullets || [];
    totalSteps = typeof options.totalSteps === 'number' ? options.totalSteps : 1;

    applyTheme(Boolean(options.isLightTheme));

    if (stepTitleEl) {
      stepTitleEl.setAttribute('value', step.title || '');
    }
    if (subtitleTextEl) {
      const subtitle = step.subtitle || '';
      subtitleTextEl.setAttribute('value', subtitle);
      subtitleTextEl.setAttribute('visible', subtitle ? 'true' : 'false');
    }
    if (bulletsTextEl) {
      bulletsTextEl.setAttribute('value', formatBullets(bullets));
      bulletsTextEl.setAttribute('visible', bullets.length ? 'true' : 'false');
    }
    if (noteTextEl) {
      const note = step.note || '';
      noteTextEl.setAttribute('value', note);
      noteTextEl.setAttribute('visible', note ? 'true' : 'false');
    }
    if (dividerEl) {
      dividerEl.setAttribute('visible', step.note ? 'true' : 'false');
    }

    applyCopyLayout(step, bullets);

    if (nextBtnEl) {
      nextBtnEl.setAttribute('ui-button', 'label', stepIndex >= totalSteps - 1 ? 'Finish' : 'Next tip');
    }

    if (prevBtnEl) {
      prevBtnEl.setAttribute('visible', stepIndex > 0 ? 'true' : 'false');
    }

    const btnGap = 10 * U;
    const btnNextW = 0.82;
    const btnSkipW = 0.92;
    const btnPrevW = 0.98;
    if (stepIndex > 0) {
      layoutFooterButtons([
        { el: nextBtnEl, width: btnNextW, gap: btnGap },
        { el: skipBtnEl, width: btnSkipW, gap: btnGap },
        { el: prevBtnEl, width: btnPrevW, gap: btnGap }
      ]);
    } else {
      layoutFooterButtons([
        { el: nextBtnEl, width: btnNextW, gap: btnGap },
        { el: skipBtnEl, width: btnSkipW, gap: btnGap }
      ]);
    }

    renderDots(stepIndex, totalSteps);
    repositionFooter(step, bullets);
    playVideo(step.video || '');
    showContainer();
    suppressBloomForTutorial();
    activeStepIndex = stepIndex;
    visible = true;
    return true;
  }

  async function ensureReady() {
    const scene = await waitForSceneReady();
    if (!scene) {
      return false;
    }
    return buildPanel();
  }

  function hide() {
    if (videoAssetEl) {
      videoAssetEl.pause();
    }
    hideContainer();
    restoreBloomAfterTutorial();
    activeStepIndex = -1;
    visible = false;
  }

  function destroy() {
    hide();
    panelEl = null;
    panelBorderEl = null;
    stepTitleEl = null;
    subtitleTextEl = null;
    bulletsTextEl = null;
    noteTextEl = null;
    dividerEl = null;
    nextBtnEl = null;
    prevBtnEl = null;
    skipBtnEl = null;
    closeHitboxEl = null;
    closeTextEl = null;
    closeBgEl = null;
    closeGroupEl = null;
    dotsRootEl = null;
    footerGroupEl = null;
    videoEntityEl = null;
    videoBgEl = null;
    mediaGroupEl = null;
    overlayMeshEl = null;
    handlers = {};
    activeStepIndex = -1;
    visible = false;
    if (rootEl) {
      rootEl.innerHTML = '';
    }
  }

  function isVisible() {
    return visible;
  }

  function getActiveStepIndex() {
    return activeStepIndex;
  }

  function getVideoEl() {
    return ensureVideoAsset();
  }

  function reposition() {
    if (!rootEl || !visible) {
      return;
    }
    showContainer();
  }

  function registerPanelComponent() {
    if (typeof AFRAME === 'undefined' || AFRAME.components['vr-tutorial-panel']) {
      return;
    }
    AFRAME.registerComponent('vr-tutorial-panel', {
      schema: {
        isShow: { type: 'boolean', default: false }
      },
      init: function () {
        this.hiddenPos = HIDDEN_POS;
        this.shownPos = SHOWN_POS;
      },
      show: function () {
        this.el.setAttribute('visible', true);
        this.el.setAttribute('position', this.shownPos);
      },
      hide: function () {
        this.el.setAttribute('visible', false);
        this.el.setAttribute('position', this.hiddenPos);
      },
      update: function (oldData) {
        if (oldData.isShow !== this.data.isShow) {
          if (this.data.isShow) {
            this.show();
          } else {
            this.hide();
          }
        }
      }
    });
  }

  registerPanelComponent();
  if (typeof document !== 'undefined') {
    document.addEventListener('DOMContentLoaded', registerPanelComponent);
  }

  global.VrTutorialNative = {
    show: setStep,
    hide: hide,
    destroy: destroy,
    setStep: setStep,
    ensureReady: ensureReady,
    isVisible: isVisible,
    getActiveStepIndex: getActiveStepIndex,
    getVideoEl: getVideoEl,
    getOverlaySvgEl: getOverlaySvgEl,
    refreshOverlayMesh: refreshOverlayMesh,
    reposition: reposition
  };
})(window);
